module.exports = __webpack_public_path__ + "img/ad.caa31f21.png";